import { EmailSignatureCache, SignatureData } from "intake_shared/src/types";

export const INTAKE_SIGNATURE_EMAIL = "intake@humantold.com";

type OlcWithEmailSignatures =
    | {
          emailSignatures?: EmailSignatureCache;
      }
    | null
    | undefined;

export function getIntakeEmailSignature(olc: OlcWithEmailSignatures): SignatureData {
    return olc?.emailSignatures?.[INTAKE_SIGNATURE_EMAIL] ?? ({} as SignatureData);
}
